import React from 'react';
import { useDispatch } from 'react-redux';
import { GetAreaListResponseItem, GetAreaListResponseLatLngList } from '../../../models/response/area/GetAreaListResponse';
import { storeActivityIndicator, storeAreYouSureModalCallback } from '../../../redux/reducers/authSlice';
import { AreaService } from '../../../services/AreaService';
import toast from "react-hot-toast";
import { DeleteAreaResponse } from '../../../models/response/area/DeleteAreaResponse';
import { GetAreaByIdResponse, GetAreaByIdResponseData } from '../../../models/response/area/GetAreaByIdResponse';
import { FocusObj, GeneralStateModel } from '../Map';

interface Props {
    isShown: boolean,
    startDrawing: () => void
    stopDrawing: (_isCancel: boolean) => void
    isPolygonDrawing: boolean
    areaList: GetAreaListResponseItem[]
    setIsShown: React.Dispatch<React.SetStateAction<boolean>>
    hiddenAreas: string[],
    setHiddenAreas: React.Dispatch<React.SetStateAction<string[]>>
    getData: (_isOneTime: boolean, _focusObj: FocusObj | undefined) => Promise<void>
    setCreateAreaModalVisible: React.Dispatch<React.SetStateAction<boolean>>
    setGeneralState: React.Dispatch<React.SetStateAction<GeneralStateModel>>
    setToBeUpdatedArea: React.Dispatch<React.SetStateAction<GetAreaByIdResponseData | undefined>>
    setIsPolygonDrawing: React.Dispatch<React.SetStateAction<boolean>>
    generalState: GeneralStateModel,
    setPolygonPoint: (mapsMouseEvent: any, _lat: number | undefined, _lng: number | undefined) => void
    removeLastPolygonPoint: () => void
    setWithKml: React.Dispatch<React.SetStateAction<boolean>>
}

const AreaDetail = ({
    isShown,
    startDrawing,
    isPolygonDrawing,
    stopDrawing,
    areaList,
    setIsShown,
    setHiddenAreas,
    hiddenAreas,
    getData,
    setCreateAreaModalVisible,
    setGeneralState,
    setToBeUpdatedArea,
    setIsPolygonDrawing,
    generalState,
    setPolygonPoint,
    removeLastPolygonPoint,
    setWithKml
}: Props) => {
    const dispatch = useDispatch();

    const changeHiddenState = (_areaId: string, _state: boolean) => {
        var hiddenAreaListStr = localStorage.getItem('HiddenAreas');
        var hiddenAreaList: string[] = hiddenAreaListStr ? JSON.parse(hiddenAreaListStr) : [];

        if (!_state)
            hiddenAreaList.push(_areaId);
        else
            hiddenAreaList = hiddenAreaList.filter(x => x != _areaId);

        setHiddenAreas(hiddenAreaList);
        localStorage.setItem("HiddenAreas", JSON.stringify(hiddenAreaList));

        getData(true, undefined);
    }

    const deleteArea = async (_areaId: string) => {
        try {
            dispatch(storeActivityIndicator(true))

            var response: DeleteAreaResponse = await AreaService.deleteArea([_areaId]);

            if (!response.isSuccess) {
                toast.error(response.message)
                dispatch(storeActivityIndicator(false))
                return;
            }

            toast.success(response.message)

            getData(true, undefined);
        } catch (error: any) {
            toast.error(error)
            dispatch(storeActivityIndicator(false))
        }
    }

    const updateArea = async (_areaId: string) => {
        try {
            dispatch(storeActivityIndicator(true))

            var response: GetAreaByIdResponse = await AreaService.getAreaById(_areaId);

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            setToBeUpdatedArea(response.data);

            setGeneralState((_generalState) => {
                _generalState.____tDrawingPolygonPoints = response.data.latLngList;

                if (_generalState.____tDrawingPolygon)
                    _generalState.____tDrawingPolygon.setMap(null);

                var p = new google.maps.Polygon({
                    paths: _generalState.____tDrawingPolygonPoints.map(function (x: any) {
                        return new google.maps.LatLng(x.lat, x.lng)
                    }),
                    strokeColor: "#FF0000",
                    strokeOpacity: 0.8,
                    strokeWeight: 2,
                    fillColor: "#FF0000",
                    fillOpacity: 0,
                    map: _generalState.____tMap,
                    zIndex: 999
                });

                p.addListener('click', (event: any) => {
                    setIsPolygonDrawing((_isPolygonDrawing) => {
                        if (_isPolygonDrawing) {
                            setPolygonPoint(undefined, event.latLng.lat(), event.latLng.lng())
                        }

                        return _isPolygonDrawing;
                    })
                })

                p.addListener('rightclick', (event: any) => {
                    setIsPolygonDrawing((_isPolygonDrawing) => {
                        if (_isPolygonDrawing) {
                            removeLastPolygonPoint();
                        }

                        return _isPolygonDrawing;
                    })
                })

                _generalState.____tDrawingPolygon = p;

                _generalState.____tOnMapClick = generalState.____tMap.addListener("click", function (mapsMouseEvent: any) {
                    setPolygonPoint(mapsMouseEvent, undefined, undefined)
                });

                _generalState.____tOnMapRightClick = generalState.____tMap.addListener("rightclick", function (mapsMouseEvent: any) {
                    removeLastPolygonPoint()
                })

                return _generalState;
            })

            setIsPolygonDrawing(true);

            mapFitBounds(response.data.latLngList)
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    const mapFitBounds = (_latLngList: GetAreaListResponseLatLngList[]) => {
        setGeneralState((_generalState) => {
            var bounds = new google.maps.LatLngBounds();

            _latLngList.map(x => new google.maps.LatLng(x.lat, x.lng)).forEach((item) => {
                bounds.extend(item);
            })

            _generalState.____tMap.fitBounds(bounds);
            return _generalState;
        });
    }

    return (
        <React.Fragment>
            {
                isShown && (
                    <div style={{ overflow: 'hidden', width: '20%', position: 'absolute', right: '15px', height: 'calc(100% - 30px)', top: '15px' }} className="menu menu-sub menu-sub-dropdown show">
                        <div className="d-flex" style={{ flexDirection: 'column', flex: 1 }}>
                            <div style={{ width: '100%' }} className="d-flex flex-grow-1">
                                <div style={{ width: '100%', flex: 1 }}>
                                    <div className="p-3">
                                        <div className="d-flex">
                                            <div className="d-flex flex-grow-1 align-items-center">
                                                <h4 style={{ lineHeight: 1 }} className="m-0">Bölgeler</h4>
                                            </div>
                                            <div className="d-flex">
                                                <i onClick={() => { setIsShown(false) }} style={{ fontSize: 24 }} className="actionIcon fa fa-times" />
                                            </div>
                                        </div>
                                    </div>

                                    <hr className="m-0" />

                                    <div className='p-3'>
                                        {
                                            areaList.map((item, index) =>
                                                <div className={`card p-3 ${(index == 0 ? '' : 'mt-3')}`}>
                                                    <div className='d-flex'>
                                                        <div className='d-flex'>
                                                            <label className="form-check form-check-sm form-check-custom form-check-solid">
                                                                <input onChange={(e) => changeHiddenState(item.areaId, e.target.checked)} className="form-check-input" type="checkbox" checked={!hiddenAreas.includes(item.areaId)} />
                                                            </label>
                                                        </div>
                                                        <div style={{ marginLeft: 10, marginRight: 10 }} className='d-flex flex-grow-1'>
                                                            <a onClick={() => mapFitBounds(item.latLngList)} href='javascript:;'>{item.areaName}</a>
                                                        </div>
                                                        <div style={{ alignItems: 'center', marginRight: 10 }} className='d-flex'>
                                                            <a href='javascript:;'>
                                                                <i
                                                                    onClick={() => updateArea(item.areaId)}
                                                                    className='fa fa-edit text-warning' />
                                                            </a>
                                                        </div>
                                                        <div style={{ alignItems: 'center' }} className='d-flex'>
                                                            <a href='javascript:;'>
                                                                <i
                                                                    onClick={() => dispatch(storeAreYouSureModalCallback(() => {
                                                                        deleteArea(item.areaId)
                                                                    }))}
                                                                    className='fa fa-trash text-danger' />
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        }
                                    </div>
                                </div>
                            </div>

                            <div className="d-flex">
                                {
                                    !isPolygonDrawing && (
                                        <React.Fragment>
                                            <div onClick={() => {
                                                startDrawing();
                                            }} style={{ flex: 1 }} className="actionIcon d-flex bg-warning py-3 justify-content-center">
                                                <i style={{ fontSize: 18 }} className={`text-black fa ${isPolygonDrawing ? 'fa-check' : 'fa-plus'}`} />

                                                <span style={{ fontWeight: 'bold', marginLeft: 5, color: 'black' }}>Manuel Çizim</span>
                                            </div>

                                            <div style={{ flex: 1 }} onClick={() => { setWithKml(true); setCreateAreaModalVisible(true); }} className="actionIcon d-flex bg-info  py-3 justify-content-center">
                                                <i style={{ fontSize: 18 }} className="text-white fa fa-upload" />
                                                <span style={{ fontWeight: 'bold', marginLeft: 5, color: 'white' }}>KML Yükle</span>
                                            </div>
                                        </React.Fragment>
                                    )
                                }

                                {
                                    isPolygonDrawing && (
                                        <React.Fragment>
                                            <div onClick={() => {
                                                stopDrawing(false);
                                            }} style={{ flex: 1 }} className="actionIcon d-flex bg-success py-3 justify-content-center">
                                                <i style={{ fontSize: 18 }} className={`text-white fa fa-check`} />
                                                <span style={{ fontWeight: 'bold', marginLeft: 5, color: 'white' }}>Onayla</span>
                                            </div>

                                            <div style={{ flex: 1 }} onClick={() => stopDrawing(true)} className="actionIcon d-flex bg-danger  py-3 justify-content-center">
                                                <i style={{ fontSize: 18 }} className="text-white fa fa-times" />
                                                <span style={{ fontWeight: 'bold', marginLeft: 5, color: 'white' }}>İptal</span>
                                            </div>
                                        </React.Fragment>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                )
            }
        </React.Fragment>
    )
}

export default AreaDetail;